const image = {
  metadata: {
    tags: [],
    concepts: [],
  },
  sys: {
    space: {
      sys: {
        type: 'Link',
        linkType: 'Space',
        id: '0sea1vycfyqy',
      },
    },
    id: '3oj4AOjSRi2ci3OtfYaopH',
    type: 'Entry',
    createdAt: '2025-03-25T19:21:21.005Z',
    updatedAt: '2025-03-25T19:21:21.005Z',
    environment: {
      sys: {
        id: 'master',
        type: 'Link',
        linkType: 'Environment',
      },
    },
    publishedVersion: 5,
    revision: 1,
    contentType: {
      sys: {
        type: 'Link',
        linkType: 'ContentType',
        id: 'image',
      },
    },
    locale: 'en-US',
  },
  fields: {
    entryName: 'Purple checkmark',
    Image: {
      metadata: {
        tags: [],
        concepts: [],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '0sea1vycfyqy',
          },
        },
        id: '4l9k52xQSx6gcwidBmkA6X',
        type: 'Asset',
        createdAt: '2025-03-25T19:21:11.733Z',
        updatedAt: '2025-03-25T19:21:11.733Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        publishedVersion: 4,
        revision: 1,
        locale: 'en-US',
      },
      fields: {
        title: 'Purple checkmark',
        description: '',
        file: {
          url: '//images.ctfassets.net/0sea1vycfyqy/4l9k52xQSx6gcwidBmkA6X/78a54ef9abdfc23e8664f93a64dd7026/Purple_Checkmark.png',
          details: {
            size: 3122,
            image: {
              width: 57,
              height: 64,
            },
          },
          fileName: 'Purple_Checkmark.png',
          contentType: 'image/png',
        },
      },
    },
    altText: 'Purple checkmark',
    componentName: 'LuvImage',
  },
};

// TODO: Replace this for an IconShortDescription entry
const subscriptionItems = [
  {
    sys: {
      id: 'unlimited-access',
      contentType: {
        sys: {
          id: 'iconShortDescription',
        },
      },
    },
    fields: {
      description:
        '<strong class="text-purple">Playthings & a book</strong> every 2-3 months',
      image,
    },
  },
  {
    sys: {
      id: 'free-access',
      contentType: {
        sys: {
          id: 'iconShortDescription',
        },
      },
    },
    fields: {
      description:
        '<strong class="text-purple">Play Guide</strong> with ways to play & tips',
      image,
    },
  },
  {
    sys: {
      id: 'early-access',
      contentType: {
        sys: {
          id: 'iconShortDescription',
        },
      },
    },
    fields: {
      description:
        '<strong class="text-purple">The Lovevery App</strong> with weekly activities<br />($144/yr value)',
      image,
    },
  },
  {
    sys: {
      id: 'exclusive-shop',
      contentType: {
        sys: {
          id: 'iconShortDescription',
        },
      },
    },
    fields: {
      description:
        '<strong class="text-purple">Parent course library</strong> ($230 value)',
      image,
    },
  },
];

export default subscriptionItems;
